import axios, { errorCallBack } from './axios';

export interface AiSummaryHealth {
    generatedAt: string;
    statsStartAt?: string;
    totals: {
        total: number;
        completed: number;
        failed: number;
        skipped: number;
        pending: number;
        completedToday: number;
        completedMonth: number;
        attemptsToday: number;
        attemptsMonth: number;
        failureEvents: number;
        failureEventsToday: number;
        costTotal: number;
        costToday: number;
        costMonth: number;
        inputTokensMonth: number;
        outputTokensMonth: number;
    };
    queue: Record<string, number>;
    statusLast30Days: Array<{ status: string; count: number }>;
    skippedLast30Days: Array<{ reason: string; count: number }>;
    failuresLast30Days: Array<{ reason: string; count: number }>;
    dailyLast14Days: Array<{ date: string; completed: number; cost: number }>;
    monthlyBreakdown: Array<{ month: string; completed: number; cost: number; inputTokens: number; outputTokens: number }>;
    topUsers: Array<{
        userId: string;
        email: string;
        summaryCount: number;
        inputTokens: number;
        outputTokens: number;
        costUsdEstimate: number;
        periodStart: string;
        periodEnd: string;
        planName: string | null;
    }>;
    recentFailures: Array<{
        summaryId: string;
        emailId: number;
        userId: string;
        email: string | null;
        errorMessage: string | null;
        failedAt: string | null;
        updatedAt: string;
    }>;
}

export const getAiSummaryHealthQuery = (): Promise<AiSummaryHealth> => {
    return axios.get('/admin/ai-summaries/health').then(({ data }) => data).catch(errorCallBack);
};
